module.exports = __webpack_public_path__ + "static/media/24UHCHR17.3366b8c6.jpg";